<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';
import Multiselect from 'vue-multiselect'


import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        Multiselect,
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                building_id: '',
                user_id: '',
                billing_data_id: '',
                company_id: '',
                start_date: '',
                end_date: '',
                payment_period_id: '',
                currency_id: '',
                bank_account_id: '',
                forced_end_date: '',
                unique_rent: false,
                unique_deposit: false,
                unique_services: false,
                signed: false,
                grace_days: '',
                deposit_amount: 0,
                departments: [],
                subtotal_rent: 0,
                apply_grace_rent: false,
                services_unique: [],
                contract_id: '',
                renew_contract_id: '',
                observations: '',
                drive:'',
                addendum: 0,
                obligation: [{ "title": "USO DEL INMUEBLE", "rules": "CASA HABITACI\u00d3N" }, { "title": "FECHA DE PAGO ", "rules": "PRIMERO DIEZ DIAS DE CADA MES" }, { "title": "SERVICIOS", "rules": "ARRENDATARIA ES LA RESPONSABLE DEL PAGO, INSTALACI\u00d3N, CANCELACI\u00d3N Y MANTENIMIENTO DE TODOS LOS SERVICIOS PUBLICOS Y PRIVADOS QUE SEAN SUMISTRADOS EN EL INMUEBLE TALES COMO AGUA, ENERGIA ELECTRICA, GAS, TELEFONO, E INTERNET, SERVICIOS DE CABLE ENTRE OTROS." }, { "title": "ESTACIONAMIENTO", "rules": "2 LUGARES DE ESTACIONAMIENTO" }, { "title": "MEJORAS", "rules": "PREVIA AUTORIZACI\u00d3N POR PARTE DEL ARRENDADOR QUEDANDO AL TERMINO DEL CONTRATO EN BENEFICIO DEL ARRENDADOR, PODR\u00c1N SER RETIRADAS AQUELLAS QUE SEAN DE FACIL DESPRENDIMIENTO" }, { "title": "SUBARRENDAMIENTO", "rules": "QUEDA EXPRESAMENTE PROHIBIDO" }, { "title": "INTERESES MORATORIOS", "rules": "EL EQUIVALENTE A LA TASA DE INTERES INTERBANCARIA TIIE M\u00c1S 50% A RAZON DEL 5 PORCIENTO MENSUAL" }, { "title": "INCREMENTO", "rules": "EN CASO DE CONTINUAR CON EL ARRENDAMIENTO POSTERIOR A LA TERMINACI\u00d3N SUFRIRA UN INCREMENTO DE LA RENTA MENSUAL CONFORME AL INDICE NACIONAL DE PRECIOS AL CONSUMIDOR DENTRO DE LOS 12 MESES ANTERIORES A LA FECHA DLE INCREMENTO" }],
            },
            send: false,
            load: false,
        }
    },
    methods: {
        addObligation() {
            let data = { title: '', rules: '' };
            this.form.obligation.push(data);
        },
        deleteObligation(index) {
            let vm = this;
            this.$swal({
                title: 'Eliminar obligación',
                text: 'Se eliminara el titulo de obligación',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    vm.form.obligation.splice(index, 1);
                }
            });
        },
        async contract(contract_id) {
            this.form.id = contract_id;

            let endpoint = '/contracts/' + contract_id;
            try {
                let { data } = await request.get(endpoint)
                if (data) {
                    console.log(data);
                    this.setData(data);
                    this.$modal.show('addNewContract');
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },
        async setData(contract) {
            this.form.id = contract.id;
            this.form.building_id = contract.building_id;
            this.form.company_id = contract.company_id;
            this.form.billing_data_id = contract.billing_data_id;
            this.form.user_id = contract.user_id;
            this.form.start_date = contract.start_date;
            this.form.end_date = contract.end_date;
            this.form.grace_days = contract.grace_days;
            this.form.payment_period_id = contract.payment_period_id;
            this.form.currency_id = contract.currency_id;
            this.form.bank_account_id = contract.bank_account_id;
            this.form.forced_end_date = contract.forced_end_date;
            this.form.unique_rent = contract.unique_rent == 1 ? true : false;
            this.form.unique_deposit = contract.unique_deposit == 1 ? true : false;
            this.form.unique_services = contract.unique_services == 1 ? true : false;
            this.form.signed = contract.signed == 1 ? true : false;
            this.form.departments = contract.departments;
            this.form.deposit_amount = contract.deposit_amount;
            this.form.observations = contract.observations;
            this.form.drive = contract.drive;
            this.form.addendum = contract.addendum;

            let vm = this;

            if (this.form.unique_rent == 1) {
                this.form.subtotal_rent = contract.unique_rent_data.subtotal;
                this.form.apply_grace_rent = contract.unique_rent_data.apply_grace == 1 ? true : false;
            } else {
                this.form.departments.forEach(function (valor, index) {
                    if (valor.pivot) {
                        console.log(valor.pivot.subtotal);
                        vm.form.departments[index].subtotal_rent = parseFloat(valor.pivot.subtotal);
                        vm.form.departments[index].apply_grace_rent = valor.pivot.apply_grace == 1 ? true : false;
                        vm.form.departments[index].include_rent = valor.pivot.include_rent == 1 ? true : false;
                        vm.form.departments[index].date = valor.pivot.date;
                    }
                });
            }

            if (this.form.unique_services == 1) {
                contract.unique_services_data.forEach(function (valor) {
                    console.log('valor');
                    console.log(valor);
                    const index = vm.form.services_unique.findIndex(s => s.service_id === valor.service_id);
                    console.log(index);
                    if (index != -1) {
                        vm.form.services_unique[index].subtotal = parseFloat(valor.subtotal);
                        vm.form.services_unique[index].apply_grace = valor.apply_grace == 1 ? true : false;
                        vm.form.services_unique[index].include_rent = valor.include_rent == 1 ? true : false;
                    } else {
                        vm.form.services_unique.push({
                            'service_id': null,
                            'name': valor.service_name,
                            'subtotal': parseFloat(valor.subtotal),
                            'deposit': parseFloat(valor.deposit),
                            'apply_grace': valor.apply_grace == 1 ? true : false,
                            'include_rent': valor.include_rent == 1 ? true : false
                        });
                    }
                });
            }


            await this.get_department_change();
            await this.get_billing_data_user();
            await this.getBankCompany();
        },
        addService() {
            this.form.services_unique.push({
                'service_id': '',
                'name': '',
                'subtotal': 0,
                'apply_grace': false,
                'include_rent': false
            });
        },
        addServiceDepartamento(index) {
            this.form.departments[index].services.push({
                service_id: '',
                name: '',
                subtotal: 0,
                apply_grace: false,
                include_rent: false,
                date: ''
            });
            console.log(this.form.departments[index].services);
            this.$forceUpdate();
        },
        customLabel(option) {
            return `Piso ${option.level} / ${option.number}`; // o cualquier combinación que quieras
        },
        getBankCompany() {
            let company = this.form.company_id;
            this.catalogue.getBankAccountCompany(company);
        },
        async get_department_change() {
            let id = this.form.building_id;
            await this.catalogue.get_departamens_buildings_available(id, ['', this.form.departments]);
            await this.catalogue.get_companies_buildings(id);

        },
        get_billing_data_user() {
            let user_id = this.form.user_id;
            this.catalogue.getBillingDataUser(user_id);
        },
        closedModal() {
            this.form.id = '';
            this.form.building_id = '';
            this.form.user_id = '';
            this.form.billing_data_id = '';
            this.form.company_id = '';
            this.form.start_date = '';
            this.form.end_date = '';
            this.form.payment_period_id = '';
            this.form.currency_id = '';
            this.form.bank_account_id = '';
            this.form.forced_end_date = '';
            this.form.unique_rent = false;
            this.form.unique_deposit = false;
            this.form.signed = false;
            this.form.unique_services = false;
            this.form.grace_days = '';
            this.form.deposit_amount = 0;
            this.form.departments = [];
            this.form.services_unique = [];
            this.form.subtotal_rent = 0;
            this.form.contract_id = '';
            this.form.renew_contract_id = '';
            this.form.observations = '';
            this.form.drive = '';
            this.form.apply_grace_rent = false;
            this.form.addendum = 0;
            this.send = false;
            this.load = false;
            this.catalogue.services.forEach(service => {
                this.form.services_unique.push({
                    'service_id': service.id,
                    'name': service.name,
                    'subtotal': 0,
                    'apply_grace': false,
                    'include_rent': false
                });
            });

            this.$modal.hide('addNewContract');
        },
        async savePayTaxes() {
            const data_form = new FormData();
            data_form.append('id', this.form.id)
            data_form.append('building_id', this.form.building_id)
            data_form.append('user_id', this.form.user_id)
            data_form.append('billing_data_id', this.form.billing_data_id)
            data_form.append('company_id', this.form.company_id)
            data_form.append('start_date', this.form.start_date)
            data_form.append('end_date', this.form.end_date)
            data_form.append('payment_period_id', this.form.payment_period_id)
            data_form.append('currency_id', this.form.currency_id)
            data_form.append('bank_account_id', this.form.bank_account_id)
            data_form.append('forced_end_date', this.form.forced_end_date)
            data_form.append('unique_rent', this.form.unique_rent)
            data_form.append('unique_deposit', this.form.unique_deposit)
            data_form.append('unique_services', this.form.unique_services)
            data_form.append('signed', this.form.signed)
            data_form.append('grace_days', this.form.grace_days)
            data_form.append('deposit_amount', this.form.deposit_amount)
            data_form.append('subtotal_rent', this.form.subtotal_rent)
            data_form.append('contract_id', this.form.contract_id)
            data_form.append('renew_contract_id', this.form.renew_contract_id)
            data_form.append('apply_grace_rent', this.form.apply_grace_rent)
            data_form.append('observations', this.form.observations)
            data_form.append('drive', this.form.drive)
            data_form.append('obligation', JSON.stringify(this.form.obligation));
            data_form.append('addendum', this.form.addendum);

            let departments = [];
            this.form.departments.forEach(department => {
                department = {
                    'id': department.id,
                    'subtotal_rent': department.subtotal_rent,
                    'deposit': department.deposit,
                    'apply_grace_rent': department.apply_grace_rent,
                    'services': department.services,
                    'date': department.date
                };
                departments.push(department);
            });
            data_form.append('departments', JSON.stringify(departments));

            data_form.append('services_unique', JSON.stringify(this.form.services_unique));

            let _endpoint = '/contracts';
            if (this.form.id != "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/contracts/${this.form.id}`;
            }

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-contracts');
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }

        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    async mounted() {
        await this.catalogue.get_buildings();
        await this.catalogue.get_users_profiles(7);
        await this.catalogue.get_payment_periods();
        await this.catalogue.getCurrencies();
        await this.catalogue.get_services();
        this.catalogue.services.forEach(service => {
            this.form.services_unique.push({
                'service_id': service.id,
                'name': service.name,
                'subtotal': 0,
                'apply_grace': false,
                'include_rent': false
            });
        });
    },
    created() {
        Event.$on("event-show-addNewContracts", async (contract) => {
            this.load = true;
            this.$modal.show('addNewContract');

            console.log('contract')
            console.log(contract);
            if (contract) {
                this.form.id = contract.id;
                this.form.building_id = contract.building_id;
                this.form.company_id = contract.company_id;
                this.form.billing_data_id = contract.billing_data_id;
                this.form.user_id = contract.user_id;
                this.form.start_date = contract.start_date;
                this.form.end_date = contract.end_date;
                this.form.grace_days = contract.grace_days;
                this.form.payment_period_id = contract.payment_period_id;
                this.form.currency_id = contract.currency_id;
                this.form.bank_account_id = contract.bank_account_id;
                this.form.forced_end_date = contract.forced_end_date;
                this.form.unique_rent = contract.unique_rent == 1 ? true : false;
                this.form.unique_deposit = contract.unique_deposit == 1 ? true : false;
                this.form.unique_services = contract.unique_services == 1 ? true : false;
                this.form.signed = contract.signed == 1 ? true : false;
                this.form.departments = contract.departments;
                this.form.deposit_amount = contract.deposit_amount;
                this.form.observations = contract.observations;
                this.form.obligation = contract.obligation;
                this.form.drive = contract.drive;
                this.form.addendum = contract.addendum;

                let vm = this;
                if (this.form.unique_rent == 1 && contract.unique_rent_data) {
                    // Renta única
                    this.form.subtotal_rent = contract.unique_rent_data.subtotal;
                    this.form.apply_grace_rent = contract.unique_rent_data.apply_grace == 1 ? true : false;
                } else {
                    // Renta por departamento
                    this.form.departments.forEach(function (valor, index) {
                        if (valor.pivot) {
                            console.log(valor.pivot.subtotal);
                            vm.form.departments[index].subtotal_rent = parseFloat(valor.pivot.subtotal);
                            vm.form.departments[index].apply_grace_rent = valor.pivot.apply_grace == 1 ? true : false;
                            vm.form.departments[index].include_rent = valor.pivot.include_rent == 1 ? true : false;
                            vm.form.departments[index].date = valor.pivot.date;
                        }
                    });
                }

                // Servicios únicos
                if (this.form.unique_services == 1 && contract.unique_services_data) {
                    contract.unique_services_data.forEach(function (valor) {
                        console.log('valor');
                        console.log(valor);
                        const index = vm.form.services_unique.findIndex(s => s.service_id === valor.service_id);
                        console.log(index);
                        if (index != -1) {
                            vm.form.services_unique[index].subtotal = parseFloat(valor.subtotal);
                            vm.form.services_unique[index].apply_grace = valor.apply_grace == 1 ? true : false;
                            vm.form.services_unique[index].include_rent = valor.include_rent == 1 ? true : false;
                        } else {
                            vm.form.services_unique.push({
                                'service_id': null,
                                'name': valor.service_name,
                                'subtotal': parseFloat(valor.subtotal),
                                'deposit': parseFloat(valor.deposit),
                                'apply_grace': valor.apply_grace == 1 ? true : false,
                                'include_rent': valor.include_rent == 1 ? true : false
                            });
                        }
                    });
                }

                // Si no existe servicio en departamento cunado no se único
                if (this.form.unique_services == 0) {
                    this.form.departments.forEach(function (valor, index) {
                        if (valor.services.length == 0) {
                            vm.catalogue.services.forEach(service => {
                                vm.form.departments[index].services.push({
                                    service_id: service.id,
                                    name: service.name,
                                    subtotal: 0,
                                    apply_grace: false,
                                    include_rent: false,
                                    date: ''
                                });
                            });
                        }
                    });

                }

                await this.get_department_change();
                await this.get_billing_data_user();
                await this.getBankCompany();
                this.load = false;
            } else {
                this.load = false;
            }
            this.$modal.show('addNewContract');
        }),
            Event.$on("event-show-renewContracts", async (contract, addendum = 0) => {
                console.log('contract');
                console.log(contract);
                console.log(addendum);

                this.load = true;
                this.$modal.show('addNewContract');
                this.form.id = '';
                this.form.building_id = contract.building_id;
                this.form.company_id = contract.company_id;
                this.form.billing_data_id = contract.billing_data_id;
                this.form.user_id = contract.user_id;
                this.form.start_date = contract.start_date;
                this.form.end_date = contract.end_date;
                this.form.grace_days = contract.grace_days;
                this.form.payment_period_id = contract.payment_period_id;
                this.form.currency_id = contract.currency_id;
                this.form.bank_account_id = contract.bank_account_id;
                this.form.forced_end_date = contract.forced_end_date;
                this.form.unique_rent = contract.unique_rent == 1 ? true : false;
                this.form.unique_deposit = contract.unique_deposit == 1 ? true : false;
                this.form.unique_services = contract.unique_services == 1 ? true : false;
                this.form.signed = contract.signed == 1 ? true : false;
                this.form.observations = contract.observations;
                this.form.departments = contract.departments;
                this.form.obligation = contract.obligation;
                this.form.drive = contract.drive;

                if (addendum != 0) {
                    this.form.addendum = addendum;
                    this.form.contract_id = contract.id;
                    this.form.renew_contract_id = '';
                }else{
                    this.form.addendum = 0;
                    this.form.contract_id = '';
                    this.form.renew_contract_id = contract.id;
                }


                this.form.deposit_amount = 0;
                let vm = this;
                if (this.form.unique_rent == 1 && contract.unique_rent_data) {
                    // Renta única
                    this.form.subtotal_rent = 0;
                    this.form.apply_grace_rent = contract.unique_rent_data.apply_grace == 1 ? true : false;
                } else {
                    // Renta por departamento
                    this.form.departments.forEach(function (valor, index) {
                        if (valor.pivot) {
                            console.log(valor.pivot.subtotal);
                            vm.form.departments[index].subtotal_rent = 0;
                            vm.form.departments[index].apply_grace_rent = valor.pivot.apply_grace == 1 ? true : false;
                            vm.form.departments[index].include_rent = valor.pivot.include_rent == 1 ? true : false;
                            vm.form.departments[index].date = valor.pivot.date;
                        }
                    });
                }

                // Servicios únicos
                if (this.form.unique_services == 1 && contract.unique_services_data) {
                    contract.unique_services_data.forEach(function (valor) {
                        console.log('valor');
                        console.log(valor);
                        const index = vm.form.services_unique.findIndex(s => s.service_id === valor.service_id);
                        console.log(index);
                        if (index != -1) {
                            vm.form.services_unique[index].subtotal = 0;
                            vm.form.services_unique[index].apply_grace = valor.apply_grace == 1 ? true : false;
                            vm.form.services_unique[index].include_rent = valor.include_rent == 1 ? true : false;
                        } else {
                            vm.form.services_unique.push({
                                'service_id': null,
                                'name': valor.service_name,
                                'subtotal': 0,
                                'deposit': 0,
                                'apply_grace': valor.apply_grace == 1 ? true : false,
                                'include_rent': valor.include_rent == 1 ? true : false
                            });
                        }
                    });
                }

                await this.get_department_change();
                await this.get_billing_data_user();
                await this.getBankCompany();
                this.load = false;
            }),
            Event.$on("event-show-showContractID", async (contract_id) => {
                this.contract(contract_id);
            })

    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
    watch: {
        'form.service_id'(nVal) {
            console.log(nVal);
            if (nVal != '') {
                this.dataPay(nVal);
            }
        },
        deep: true,
        'form.departments': {
            handler(newDepartments) {
                newDepartments.forEach(dept => {
                    if (!dept.services) {
                        // Clonamos el catálogo de servicios para este departamento
                        dept.services = this.catalogue.services.map(service => ({
                            service_id: service.id,
                            name: service.name,
                            subtotal: 0,
                            apply_grace: false,
                            include_rent: false,
                            date: ''
                        }));
                    }
                });
            },
            immediate: true,
            deep: true
        }

    },
}
</script>
<template>
    <modal name="addNewContract" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()">
            <i class="fa-solid fa-xmark"></i>
        </button>
        <form @submit.prevent="savePayTaxes" method="post" id="formTax" enctype="multipart/form-data">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Información del Contrato</h5>
            </div>
            <div class="modal-body">
                <div class="row" v-if="load">
                    <div class="col-md-12 text-center">
                        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        <br>
                        Cargando...
                    </div>
                </div>
                <div v-else class="row">
                    <div class="col-md-4 mt-2">
                        <label>Propiedad</label><br>
                        <select :disabled="!prop_edit || form.id != ''" class="form-control" v-model="form.building_id"
                            @change="get_department_change()">
                            <option value="">Sin propiedad</option>
                            <option :value="building.id" v-for="(building, building_index) in catalogue.buildings"
                                :key="building_index">
                                {{ building.name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.building_id" class="text-danger">{{ errors.building_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Arrendatario</label><br>
                        <select :disabled="!prop_edit || form.id != ''" class="form-control" v-model="form.user_id"
                            @change="get_billing_data_user()">
                            <option value="">Sin arrendatario</option>
                            <option :value="user.id" v-for="(user, user_index) in catalogue.users_profiles"
                                :key="user_index">
                                {{ user.name }} {{ user.last_name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.user_id" class="text-danger">{{ errors.user_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Datos de Facturación</label>
                        <select :disabled="!prop_edit || form.id != ''" type="text" class="form-control"
                            v-model="form.billing_data_id">
                            <option value="">Sin datos de facturación</option>
                            <option v-for="(billD, index) in catalogue.billing_data_user" :value="billD.id"
                                :key="index">{{
                                    billD.business_name }} - {{ billD.rfc }}</option>
                        </select>
                        <div v-if="errors && errors.billing_data_id" class="text-danger">{{ errors.billing_data_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Empresa</label>
                        <select type="text" :disabled="!prop_edit || form.id != ''" class="form-control"
                            v-model="form.company_id" @change="getBankCompany">
                            <option value="">Sin Empresa</option>
                            <option v-for="(company, index_company) in catalogue.companies_buildings"
                                :value="company.id" :key="index_company">
                                {{ company.name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.company_id" class="text-danger">{{ errors.company_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Fecha inicio</label>
                        <date-picker :disabled="!prop_edit || form.id != ''" valueType="format"
                            v-model="form.start_date"></date-picker>
                        <div v-if="errors && errors.start_date" class="text-danger">{{ errors.start_date[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Fecha fin</label>
                        <date-picker :disabled="!prop_edit" valueType="format" v-model="form.end_date"></date-picker>
                        <div v-if="errors && errors.end_date" class="text-danger">{{ errors.end_date[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Recurrencia</label>
                        <select :disabled="!prop_edit" class="form-control" v-model="form.payment_period_id">
                            <option value="">Sin recurrencia</option>
                            <option v-for="(payment_period, index) in catalogue.payment_periods"
                                :value="payment_period.id" :key="index">
                                {{ payment_period.name }}</option>
                        </select>
                        <div v-if="errors && errors.payment_period_id" class="text-danger">{{
                            errors.payment_period_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Moneda</label>
                        <select type="text" :disabled="!prop_edit" class="form-control" v-model="form.currency_id">
                            <option value="">Sin moneda</option>
                            <option v-for="(currency, index) in catalogue.currencies" :value="currency.id" :key="index">
                                {{ currency.name }}</option>
                        </select>
                        <div v-if="errors && errors.currency_id" class="text-danger">{{ errors.currency_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Cuenta de banco</label>
                        <select class="form-control" :disabled="!prop_edit" v-model="form.bank_account_id">
                            <option value="">Selecciona una cuenta</option>
                            <option :value="bank.id" v-for="(bank, index) in catalogue.bank_account_company"
                                :key="index">
                                <span v-if="bank.bank">{{ bank.bank.name }} | </span> {{ bank.name }} - {{ bank.number
                                }}
                            </option>
                        </select>
                        <div v-if="errors && errors.bank_account_id" class="text-danger">{{
                            errors.bank_account_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Fecha fin plazo forzoso</label>
                        <date-picker :disabled="!prop_edit" valueType="format"
                            v-model="form.forced_end_date"></date-picker>
                        <div v-if="errors && errors.forced_end_date" class="text-danger">{{ errors.forced_end_date[0] }}
                        </div>
                    </div>

                    <div class="col-md-3 mt-2 text-center">
                        <label>Contrato firmado</label>
                        <input type="checkbox" :disabled="!prop_edit" class="form-control form-control-sm"
                            v-model="form.signed">
                        <div v-if="errors && errors.signed" class="text-danger">{{ errors.signed[0] }}
                        </div>
                    </div>

                    <div class="col-md-2 mt-2 text-center">
                        <label>Renta única</label>
                        <input type="checkbox" :disabled="!prop_edit" class="form-control form-control-sm"
                            v-model="form.unique_rent">
                        <div v-if="errors && errors.unique_rent" class="text-danger">{{ errors.unique_rent[0] }}
                        </div>
                    </div>

                    <div class="col-md-3 mt-2 text-center">
                        <label>Pago único de servicios</label>
                        <input type="checkbox" :disabled="!prop_edit" class="form-control form-control-sm"
                            v-model="form.unique_services">
                        <div v-if="errors && errors.unique_services" class="text-danger">{{ errors.unique_services[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Días de gracia</label>
                        <date-picker :disabled="!prop_edit" valueType="format" v-model="form.grace_days"></date-picker>
                        <div v-if="errors && errors.grace_days" class="text-danger">{{ errors.grace_days[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2 text-center">
                        <label>Depósito único</label>
                        <input type="checkbox" :disabled="!prop_edit" class="form-control form-control-sm"
                            v-model="form.unique_deposit">
                        <div v-if="errors && errors.unique_deposit" class="text-danger">{{ errors.unique_deposit[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2" v-if="form.unique_deposit">
                        <label>Deposito de garantía</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.deposit_amount"></money>
                        <div v-if="errors && errors.deposit_amount" class="text-danger">{{ errors.deposit_amount[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mt-2">
                        <label>Observaciones</label>
                        <textarea :disabled="!prop_edit" class="form-control" v-model="form.observations"
                            rows="3"></textarea>
                        <div v-if="errors && errors.observations" class="text-danger">{{ errors.observations[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mt-2">
                        <label>Link recursos</label>
                        <input :disabled="!prop_edit" class="form-control" v-model="form.drive">
                        <div v-if="errors && errors.drive" class="text-danger">{{ errors.drive[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mt-2">
                        <label>Departamentos</label>
                        <multiselect :disabled="!prop_edit" v-model="form.departments"
                            placeholder="Buscar un departamento" :custom-label="customLabel" track-by="id"
                            :options="catalogue.departamens_available" :multiple="true">
                        </multiselect>
                        <div v-if="errors && errors.departments" class="text-danger">{{ errors.departments[0] }}
                        </div>
                    </div>

                    <!-- Pago de renta -->
                    <!-- Unica -->
                    <div class="col-md-12" v-if="form.unique_rent">
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card bg-light">
                                    <div class="card-body p-1">
                                        <div class="row">
                                            <div class="col-md-10">
                                                <label>Pago de renta unica</label>
                                                <money :disabled="!prop_edit" class="form-control"
                                                    v-model="form.subtotal_rent"></money>
                                                <div v-if="errors && errors.subtotal_rent" class="text-danger">{{
                                                    errors.subtotal_rent[0] }}
                                                </div>
                                            </div>
                                            <div class="col-md-2 text-center">
                                                <label>Aplica gracia</label>
                                                <input type="checkbox" :disabled="!prop_edit"
                                                    class="form-control form-control-sm"
                                                    v-model="form.apply_grace_rent">
                                                <div v-if="errors && errors.apply_grace_rent" class="text-danger">{{
                                                    errors.apply_grace_rent[0] }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Pago de renta -->
                    <div class="col-md-12" v-if="form.unique_rent == false || form.unique_deposit == false">
                        <hr>
                        <div class="row" v-for="(department, index) in form.departments" :key="'dept-' + index">
                            <div class="col-md-12">
                                <div class="card bg-light">
                                    <div class="card-body p-1">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <label>Indiviso</label><br>
                                                <label> Piso {{ department.level }} / {{ department.number }}</label>
                                            </div>
                                            <div class="col-md-4" v-if="!form.unique_rent">
                                                <label>Subtotal</label>
                                                <money :disabled="!prop_edit" class="form-control"
                                                    v-model="department.subtotal_rent"></money>
                                                <div v-if="errors && errors[`departments.${index}.subtotal_rent`]"
                                                    class="text-danger">
                                                    {{ errors[`departments.${index}.subtotal_rent`][0] }}
                                                </div>
                                            </div>
                                            <div class="col-md-3" v-if="!form.unique_deposit">
                                                <label>Deposito</label>
                                                <money :disabled="!prop_edit" class="form-control"
                                                    v-model="department.deposit"></money>
                                                <div v-if="errors && errors[`departments.${index}.deposit`]"
                                                    class="text-danger">
                                                    {{ errors[`departments.${index}.deposit`][0] }}
                                                </div>
                                            </div>
                                            <div class="col-md-2 text-center" v-if="!form.unique_rent">
                                                <label>Aplica gracia</label>
                                                <input type="checkbox" :disabled="!prop_edit"
                                                    class="form-control form-control-sm"
                                                    v-model="department.apply_grace_rent">
                                                <div v-if="errors && errors.apply_grace_rent" class="text-danger">{{
                                                    errors.apply_grace_rent[0] }}
                                                </div>
                                            </div>
                                            <div class="col-md-3" v-if="!form.unique_rent">
                                                <label>Fecha registro</label>
                                                <date-picker :disabled="!prop_edit" valueType="format"
                                                    v-model="department.date"></date-picker>
                                                <div v-if="errors && errors[`departments.${index}.date`]"
                                                    class="text-danger">
                                                    {{ errors[`departments.${index}.date`][0] }}
                                                </div>
                                            </div>
                                            <!-- Servicios -->
                                            <div class="col-md-12 mt-4" v-if="!form.unique_services">
                                                <div class="row" v-for="(service, index_service) in department.services"
                                                    :key="index_service">
                                                    <div class="col-md-12">
                                                        <div class="card bg-light">
                                                            <div class="card-body p-1">
                                                                <div class="row">
                                                                    <div class="col-md-2"
                                                                        v-if="service.service_id != ''">
                                                                        <label>Servicio</label><br>
                                                                        <label> {{ service.name }}</label>
                                                                    </div>
                                                                    <div class="col-md-2" v-else>
                                                                        <label>Servicio</label><br>
                                                                        <input type="text" :disabled="!prop_edit"
                                                                            class="form-control" v-model="service.name">
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <label>Subtotal</label>
                                                                        <money :disabled="!prop_edit"
                                                                            class="form-control"
                                                                            v-model="service.subtotal"></money>
                                                                        <div v-if="errors && errors[`departments.${index}.services.${index_service}.subtotal`]"
                                                                            class="text-danger">
                                                                            {{
                                                                                errors[`departments.${index}.services.${index_service}.subtotal`][0]
                                                                            }}
                                                                        </div>

                                                                    </div>
                                                                    <div class="col-md-2 text-center">
                                                                        <label>Aplica gracia</label>
                                                                        <input type="checkbox" :disabled="!prop_edit"
                                                                            class="form-control form-control-sm"
                                                                            v-model="service.apply_grace">
                                                                        <div v-if="errors && errors.apply_grace"
                                                                            class="text-danger">{{
                                                                                errors.apply_grace[0] }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-2 text-center">
                                                                        <label>Incluido en renta</label>
                                                                        <input type="checkbox" :disabled="!prop_edit"
                                                                            class="form-control form-control-sm"
                                                                            v-model="service.include_rent">
                                                                        <div v-if="errors && errors.include_rent"
                                                                            class="text-danger">{{
                                                                                errors.include_rent[0] }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12 text-center" v-if="prop_edit">
                                                        <button type="button" class="btn-outline-success btn"
                                                            @click="addServiceDepartamento(index)">
                                                            <i class="fa fa-plus"></i> Agregar Servicio
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Servicios únicos -->
                    <div class="col-md-12" v-if="form.unique_services">
                        <hr>
                        <div class="row" v-for="(service, index) in form.services_unique" :key="index">
                            <div class="col-md-12">
                                <div class="card bg-light">
                                    <div class="card-body p-1">
                                        <div class="row">
                                            <div class="col-md-2" v-if="service.service_id != ''">
                                                <label>Servicio</label><br>
                                                <label> {{ service.name }}</label>
                                            </div>
                                            <div class="col-md-2" v-else>
                                                <label>Servicio</label><br>
                                                <input type="text" :disabled="!prop_edit" class="form-control"
                                                    v-model="service.name">
                                                <div v-if="errors && errors[`services_unique.${index}.name`]"
                                                    class="text-danger">
                                                    {{ errors[`services_unique.${index}.name`][0] }}
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label>Subtotal</label>
                                                <money :disabled="!prop_edit" class="form-control"
                                                    v-model="service.subtotal"></money>
                                                <div v-if="errors && errors[`services_unique.${index}.subtotal`]"
                                                    class="text-danger">
                                                    {{ errors[`services_unique.${index}.subtotal`][0] }}
                                                </div>
                                            </div>
                                            <div class="col-md-2 text-center">
                                                <label>Aplica gracia</label>
                                                <input type="checkbox" :disabled="!prop_edit"
                                                    class="form-control form-control-sm" v-model="service.apply_grace">
                                                <div v-if="errors && errors.apply_grace" class="text-danger">{{
                                                    errors.apply_grace[0] }}
                                                </div>
                                            </div>
                                            <div class="col-md-2 text-center">
                                                <label>Incluido en renta</label>
                                                <input type="checkbox" :disabled="!prop_edit"
                                                    class="form-control form-control-sm" v-model="service.include_rent">
                                                <div v-if="errors && errors.include_rent" class="text-danger">{{
                                                    errors.include_rent[0] }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-center" v-if="prop_edit">
                                <button type="button" class="btn-outline-success btn" @click="addService()">
                                    <i class="fa fa-plus"></i> Agregar Servicio
                                </button>
                            </div>
                        </div>

                    </div>


                    <div class="col-md-12">
                        <hr>
                        <div class="row">
                            <div class="col-12">
                                <label>Título de obligación</label>
                                <div class="row justify-content-center mb-3" v-if="prop_edit">
                                    <div class="col-md-6">
                                        <button type="button" class="btn btn-block btn-success"
                                            @click="addObligation()">
                                            <i class="fa fa-plus"></i> Título de obligación
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 " v-for="(value, index_value) in form.obligation" :value="index_value"
                                :key="index_value">
                                <button class="btn btn-sm btn-danger btnDel" type="button" v-if="prop_edit"
                                    @click="deleteObligation(index_value)"><i class="fa fa-trash"></i> </button>
                                <div class="row divCard m-1">
                                    <div class="col-12">
                                        <label>Título:</label>
                                        <input class="form-control" :disabled="!prop_edit" v-model="value.title">
                                    </div>
                                    <div class="col-12">
                                        <label>Descripción:</label>
                                        <textarea class="form-control" :disabled="!prop_edit"
                                            v-model="value.rules"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <hr>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>
                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </modal>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
